module.exports = __webpack_public_path__ + "static/media/icon-1.69f28000.png";